module.exports = __webpack_public_path__ + "img/no-image.403a81a6.jpg";